import { Search } from '@repo/go-icons';
import { Input, Loader, RadioButtonGroup } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useStore } from 'src/store';
import { GOPLAN_COLOR_PALETTE_EDITING } from 'src/store/roles-store/roles';

import { ColorsBlock } from './colors-block';
import { DirectoriesList } from './directories-list';
import styles from './palette-settings.module.scss';
import type { PaletteSettingsStore } from './palette-settings.store';

type Props = {
  store: PaletteSettingsStore;
};

export const PaletteSettings = observer<Props>(function PaletteSettings({ store }) {
  const { t } = useTranslation();
  const { rolesStore } = useStore();
  const directoriesStatusGroupsIds = useMemo(() => {
    return [
      {
        label: t('drillingCarpet:Compare.actual'),
        value: 'active',
      },
      {
        label: t('drillingCarpet:Compare.archive'),
        value: 'archived',
      },
    ];
  }, [t]);

  useEffect(() => {
    return store.init();
  }, [store]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.headersBlock}>
        <RadioButtonGroup
          size="l"
          className={styles.radioGroup}
          value={store.dictsStatus}
          items={directoriesStatusGroupsIds}
          onChange={(v) => {
            if (v === 'active' || v === 'archived') {
              store.setDictsStatus(v);
            }
          }}
        />
        <Input
          value={store.searchValue}
          onChange={(e) => store.setSearchValue(e.target.value)}
          className={styles.searchInput}
          prefix={<Search />}
          placeholder={t('common:search')}
        />
        {store.isLoading && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <p className="body-l">{t('systemSettings:Common.updatingData')}</p>
            <Loader
              style={{
                position: 'static',
                backgroundColor: 'transparent',
              }}
              size="s"
            />
          </div>
        )}
      </div>
      <div className={styles.contentWrapper}>
        <DirectoriesList store={store} />
        <div className={styles.divider} />
        {rolesStore.hasAccess([GOPLAN_COLOR_PALETTE_EDITING]) && <ColorsBlock store={store} />}
      </div>
    </div>
  );
});
